<template>
    <div>
      <el-table
      :cell-style="{padding:'0px'}"
        ref="dataTable"
        :data="tableData"
        style="width: 100%; min-height: 150px; font-size: 12px"
        size="mini"
        stripe
        row-key="id"
        :height='height'
        :load="load"
        :lazy="lazy"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        v-loading="listLoading"
        highlight-current-row
        @selection-change="selectLine"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellClassName"
        @cell-click="tableCellClick"
        @expand-change="expandChange"
      >
        <!-- 多选框 -->
        <el-table-column
          v-if="selection"
          type="selection"
          width="55"
          :align="align"
        ></el-table-column>
        <el-table-column v-if="expand" type="expand">
          <template slot-scope="props">
            <slot name="expand" :data="props" />
          </template>
        </el-table-column>
        <!-- 文本数据渲染 -->
        <template v-for="item in tableHead">
          <el-table-column
            v-if="item.columnType === 'slot'"
            :prop="item.field"
            :label="item.label"
            :key="item.field"
            :width="item.width"
            :fixed="item.fixed"
            :align="align"
          >
            <template slot-scope="scope">
              <slot :name="item.slotName" :data="scope" />
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :prop="item.field"
            :label="item.label"
            :key="item.field"
            :width="item.width"
            :align="align"
            :show-overflow-tooltip="item.tooltip"
          ></el-table-column>
        </template>
        <div class="no-message" slot="empty">
          <!-- <img src="~@/assets/pic/common/empty.png" alt="" /> -->
          <div class="info1">暂无内容</div>
        </div>
      </el-table>
  
      <pagination
        v-show="tableData.length > 0"
        :total="paginationData.total"
        @pagination="pageHandler"
        :page.sync="paginationData.current"
        :limit.sync="paginationData.pageSize"
      />
    </div>
  </template>
  
  <script>
  import pagination from "@/components/Pagination";
  export default {
    name: "e-table",
    components: { pagination },
    props: {
      tableHeadConfig: {
        type: Array,
        default: () => {
          return [];
        },
      },
      load: {
        type: Function,
        default: () => {
          return [];
        },
      },
      tableLoadData: {
        type: Array,
        default: () => {
          return [];
        },
      },
      tableRowClassName: {
        type: Function,
        default: () => {
          return "";
        },
      },
      tableCellClassName: {
        type: Function,
        default: () => {
          return "";
        },
      },
      tableCellClick: {
        type: Function,
        default: () => {
          return "";
        },
      },
      align: {
        type: String,
        default: "center",
      },
      selection: {
        type: Boolean,
        default: false,
      },
      expand: {
        type: Boolean,
        default: false,
      },
      lazy: {
        type: Boolean,
        default: false,
      },
      height: {
        type: [Number, String],
        default: "initial",
      },
  
      listLoading: {
        type: Boolean,
        default: false,
      },
      paginationData: {
        type: Object,
        default: () => {
          return { page: 1, limit: 10, total: 0 };
        },
      },
    },
    data() {
      return {};
    },
    created() {},
    mounted() {},
    methods: {
      pageHandler() {
        this.$emit("pageChange");
      },
      selectLine() {
        this.$emit("selectLine", this.$refs.dataTable.selection[this.$refs.dataTable.selection.length - 1]);
      },
      expandChange (row, expandedRows) {
        console.log(row, expandedRows);
          this.$emit("expandChange", { row, expandedRows});
      }
    },
    computed: {
      tableData() {
        let { current, pageSize, total} = this.paginationData;
        let data =this.tableLoadData;
        data = data.slice((current - 1) * pageSize, current * pageSize);
        return data;
      },
      tableHead() {
        return this.tableHeadConfig;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-table {
    margin-bottom: 20px;
    ::v-deep th {
      padding: 0;
    }
    ::v-deep td {
      padding: 0;
    }
  ::v-deep.el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
  }
  ::v-deep.el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 10px;
  }
  ::v-deep.el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 10px; /*滚动条的圆角*/
      background-color: #c1c1c1;
  }
  }
  ::v-deep.el-table .danger-row .el-table__cell {
    background: #fd9e9e !important;
  }
  ::v-deep.el-table .warning-row .el-table__cell {
    background: oldlace !important;
  }
  ::v-deep.el-table .success-row .el-table__cell {
    background: #f0f9eb !important;
  }
  
  ::v-deep.el-table .success-row .el-table__cell {
    background: #f0f9eb !important;
  }
  // /deep/.el-table__empty-block {
  //   height: 417px !important;
  // }
  // /deep/.el-table__body-wrapper {
  //   height: auto !important;
  // }
  .no-message {
    height: 480px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    i {
      display: inline-block;
      width: 98px;
      height: 98px;
      margin-bottom: 24px;
    }
    .info1 {
      font-size: 14px;
      font-weight: 500;
      color: #666;
      line-height: 22px;
      margin-bottom: 8px;
    }
    .info2 {
      font-size: 12px;
      font-weight: 400;
      color: #909399;
      line-height: 20px;
    }
  }
  ::v-deep.pagination-container {
    padding: 0;
    margin: 0;
  }
  ::v-deep.navbar {
    display: none;
  }
  </style>
  